import Konva from "konva";

const INSTALL_FLAG = "__gleanAgWillReadFrequentlyInstalled";

type PatchedKonvaUtil = typeof Konva.Util & {
  [INSTALL_FLAG]?: boolean;
};

export function installKonvaCanvasReadbackHint(): void {
  if (typeof document === "undefined") return;

  const util = Konva.Util as PatchedKonvaUtil;
  if (util[INSTALL_FLAG]) return;
  util[INSTALL_FLAG] = true;

  const originalCreateCanvasElement = util.createCanvasElement.bind(util);
  util.createCanvasElement = () => {
    const canvas = originalCreateCanvasElement();
    const originalGetContext = canvas.getContext.bind(canvas);

    canvas.getContext = function patchedCanvasGetContext(
      contextId: string,
      options?: CanvasRenderingContext2DSettings | ImageBitmapRenderingContextSettings | WebGLContextAttributes
    ) {
      if (contextId !== "2d") {
        return originalGetContext(contextId, options);
      }
      return originalGetContext.call(this, contextId, {
        ...(options && typeof options === "object" ? options : {}),
        willReadFrequently: true,
      } as CanvasRenderingContext2DSettings);
    } as typeof canvas.getContext;

    return canvas;
  };
}
